import { useSelector } from 'react-redux';

export const normalizeRole = (roleValue) => {
    if (typeof roleValue === 'number' && Number.isFinite(roleValue)) {
        return roleValue;
    }

    if (typeof roleValue === 'string') {
        const parsedRole = Number(roleValue);
        return Number.isFinite(parsedRole) ? parsedRole : 0;
    }

    if (roleValue && typeof roleValue === 'object') {
        const firstRoleKey = Object.keys(roleValue)[0];
        const parsedRole = Number(firstRoleKey);
        return Number.isFinite(parsedRole) ? parsedRole : 0;
    }

    return 0;
};

export const useRole = () => {
    const roleValue = useSelector(state => state.Auth.role);
    return normalizeRole(roleValue);
}
